import { AccountingPlatformCategory, BillSubscriptionEndPolicyEnum } from '@melio/platform-api';

export type AddInstantBillV2FormActivityFields = {
  vendorId: string;
  billAmount: string;
  paymentFrequency: string;
  categoryId?: AccountingPlatformCategory['id'];
  startDate?: Date;
  endPolicy?: BillSubscriptionEndPolicyEnum;
  numOfOccurrences?: number;
  endDate?: Date;
  invoiceNumber?: string;
};

const baseFields = ['vendorId', 'billAmount', 'paymentFrequency', 'categoryId'];
export const singlePaymentFields = baseFields;
export const recurringNumOfOccurrencesFields = baseFields.concat(['startDate', 'endPolicy', 'numOfOccurrences']);
export const recurringEndDateFields = baseFields.concat(['startDate', 'endPolicy', 'endDate']);
